module.exports = "<label *ngIf=\"label\" class=\"control-label\" [for]=\"model.name\">\n    {{label}}</label>\n<div>\n    <ng-content></ng-content>\n</div>\n<div *ngIf=\"microcopia\" class=\"microcopia\">{{microcopia}}</div>\n<div *ngIf=\"hasErrorClass\" class=\"help-block\">\n    <div *ngFor=\"let item of errorMessagesForView\" [class.hidden]=\"!hasError(item.error)\">\n        {{item.message}}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/vertical-input-container/vertical-input-container.component.html
// module id = ./src/app/common/vertical-input-container/vertical-input-container.component.html
// module chunks = main